import React from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-[#f5f1e8]/85 backdrop-blur-md border-b border-[#e8ddc3]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/txcaddf3_logo%20def1.png"
            alt="Retrato Mascotas"
            className="h-14 md:h-16 w-auto"
          />
          <img
            src="https://customer-assets.emergentagent.com/job_pet-portraits-4/artifacts/sh7tvxjx_logo%20def2.png"
            alt="Retrato Mascotas"
            className="hidden sm:inline-block h-7 md:h-8 w-auto"
          />
        </a>
        <nav className="hidden md:flex items-center gap-10 text-sm text-[#1a1816]/80">
          <button onClick={() => scrollTo("ejemplo")} className="hover:text-[#b59557] transition-colors">
            Ejemplo
          </button>
          <button onClick={() => scrollTo("proceso")} className="hover:text-[#b59557] transition-colors">
            Proceso
          </button>
          <button onClick={() => scrollTo("estilos")} className="hover:text-[#b59557] transition-colors">
            Estilos
          </button>
          <button onClick={() => scrollTo("calidad")} className="hover:text-[#b59557] transition-colors">
            Calidad
          </button>
          <button onClick={() => scrollTo("opiniones")} className="hover:text-[#b59557] transition-colors">
            Opiniones
          </button>
        </nav>
        <button
          onClick={() => scrollTo("estilos")}
          className="btn-primary rounded-full px-5 py-2.5 text-sm font-medium"
        >
          Ver estilos
        </button>
      </div>
    </header>
  );
}
